// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import type { BrandSpecial } from '@iheartjane/data-access';
import { Box, PartnerLogo, ReadMore, Typography } from '@iheartjane/reefer';

import { useShouldShowGold } from '@jane/shared/hooks';
/* eslint-disable-next-line no-restricted-imports */
import type { Brand } from '@jane/shared/models';

import { JaneGoldSubheader } from './janeGoldSubheader/janeGoldSubheader';

const MobileBrandContainer = styled.div({
  marginTop: '-75px',
  position: 'relative' as const,
});

const PartnerLogoContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
});

const StyledBrandName = styled(Typography)<{ forceMobile?: boolean }>(
  ({ forceMobile }) => ({
    '&&': {
      fontSize: forceMobile ? 28 : undefined,
      textAlign: forceMobile ? 'center' : undefined,
    },
  })
);

const StyledDescription = styled(Typography)<{ forceMobile?: boolean }>(
  ({ forceMobile }) => ({
    '&&': {
      fontSize: forceMobile ? 15 : undefined,
      textAlign: forceMobile ? 'center' : undefined,
    },
  })
);

export const MobileBrandDetail = ({
  brand,
  brandSpecials = [],
  forceMobile,
  isGuestUser,
  isJaneGoldMember,
}: {
  brand: Brand;
  brandSpecials?: BrandSpecial[];
  forceMobile?: boolean;
  isGuestUser?: boolean;
  isJaneGoldMember?: boolean;
}) => {
  const { name, logo_url, description } = brand;

  const shouldShowGold = useShouldShowGold() && brandSpecials.length > 0;

  return (
    <MobileBrandContainer data-testid="brand-detail-mobile">
      <Box mx={24} py={24} pb={24}>
        <PartnerLogoContainer>
          <PartnerLogo variant="brand" name={name} image={logo_url} />
        </PartnerLogoContainer>
        <StyledBrandName
          variant="title-bold"
          mt={16}
          textAlign="center"
          forceMobile={forceMobile}
        >
          {name}
        </StyledBrandName>
        {description && (
          <StyledDescription
            mt={8}
            as="h2"
            forceMobile={forceMobile}
            whiteSpace="pre-wrap"
          >
            <ReadMore
              content={description}
              more="View more"
              less="View less"
              characters={135}
            />
          </StyledDescription>
        )}
        {shouldShowGold && (
          <JaneGoldSubheader
            brandName={name}
            isGuestUser={isGuestUser}
            isJaneGoldMember={isJaneGoldMember}
          />
        )}
      </Box>
    </MobileBrandContainer>
  );
};
